/* rockkt-consent-v1.js -- cookie consent, the Google Ads tag and conversions, for rockkt.com
   AND app.rockkt.com (Glen, 9 Oct 2026). ONE FILE, TWO COPIES: the master is
   public/rockkt-consent-v1.js in the app repo; the Shopify theme carries a byte-identical
   assets/rockkt-consent-v1.js. Change one, change both, and bump the version (v2) in both.

   UK PECR + Google Consent Mode v2, "basic" mode:
   - Consent defaults to DENIED for ad_storage, ad_user_data, ad_personalization and
     analytics_storage before anything else runs.
   - The Google tag (gtag.js for AW-11015921340) is NOT LOADED AT ALL until the visitor allows
     Advertising. Nothing is fetched from Google before that. (Analytics is recorded as a choice
     for the day a GA4 tag is added; on its own it loads nothing, because the only tag is Ads.)
   - The choice lives in one cookie, rk_consent, on .rockkt.com, so a choice on rockkt.com
     covers app.rockkt.com and the other way round. 180 days.
   - Reject is exactly as easy as Accept (same size, same row). Nothing is pre-ticked.
   - "Cookie settings" reopens the choice: any element with data-rk-cookie-settings, a
     href="#cookie-settings", and a link this script adds to every rockkt.com footer.
   - The homepage's own banner (#cookie, rockkt-cookie-v1.js) is WIRED to this rather than
     shown beside it: its buttons write this cookie, it gains an Advertising switch, and its
     dead Cookie Policy link points at the policy.

   CONVERSIONS: window.rkConversion(name, opts). Fires only when Advertising is allowed, at
   most once per conversion key (kept in this browser), with the email sent as Enhanced
   Conversions user_data. Callers call it only after the server has said yes.

   Recipient pages on the app (/confirm, /claim, /v, /deck, /track ...) are opened by people
   who were SENT something, not by prospects: no banner and no tag there.

   No em dashes in any visible text. Plain ES5, no build step. */
(function () {
  if (window.rkConsent) return;
  var TAG = 'AW-11015921340';
  var CONVERSIONS = {
    studio_signup: { label: 'ODkoCIHvgpYdELy95oQp', value: 5 },
    demo:          { label: 'HFFZCITvgpYdELy95oQp', value: 50 },
    purchase:      { label: 'OJzLCIfvgpYdELy95oQp', value: 0 },
    /* Glen to send the label. Empty = switched off: nothing fires. */
    free_sample:   { label: '', value: 30 }
  };
  var COOKIE = 'rk_consent';
  var DAYS = 180;
  var POLICY_URL = 'https://cdn.shopify.com/s/files/1/0608/8651/5880/files/rockkt-cookie-policy.pdf';
  var host = location.hostname;
  var onRockkt = /(^|\.)rockkt\.com$/i.test(host);
  /* The app's recipient pages. Matched on every host except rockkt.com itself (whose Shopify
     paths are /pages/..., /blogs/..., never these), so the app's previews behave the same. */
  var QUIET = /^\/(confirm|claim|v|deck|deck-preview|track|s|preview-v1|preview)(\/|$)/;
  var quiet = !/^(www\.)?rockkt\.com$/i.test(host) && QUIET.test(location.pathname);

  /* ---- Consent Mode defaults: before anything else ---- */
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  if (!window.gtag) window.gtag = gtag;
  window.gtag('consent', 'default', {
    ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied',
    analytics_storage: 'denied', functionality_storage: 'granted', security_storage: 'granted'
  });
  window.gtag('set', 'ads_data_redaction', true);

  /* ---- the cookie ---- */
  function readChoice() {
    var m = document.cookie.match(/(?:^|;\s*)rk_consent=([^;]*)/);
    if (!m) return null;
    try {
      var v = JSON.parse(decodeURIComponent(m[1]));
      if (!v || v.v !== 1) return null;
      return { analytics: v.a === true, advertising: v.m === true, at: v.t || 0 };
    } catch (e) { return null; }
  }
  function writeChoice(c) {
    var val = encodeURIComponent(JSON.stringify({ v: 1, a: !!c.analytics, m: !!c.advertising, t: Date.now() }));
    var parts = [COOKIE + '=' + val, 'path=/', 'max-age=' + (DAYS * 86400), 'SameSite=Lax'];
    if (onRockkt) parts.push('domain=.rockkt.com');
    if (location.protocol === 'https:') parts.push('Secure');
    document.cookie = parts.join('; ');
  }

  /* ---- the tag, only after Advertising is allowed ---- */
  var tagLoaded = false;
  function loadTag() {
    if (tagLoaded || quiet) return;
    tagLoaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + TAG;
    s.setAttribute('data-rk-consent', 'v1');
    (document.head || document.documentElement).appendChild(s);
    window.gtag('js', new Date());
    window.gtag('config', TAG, {
      linker: { domains: ['rockkt.com', 'app.rockkt.com'], accept_incoming: true },
      allow_enhanced_conversions: true
    });
  }
  var current = readChoice();
  function apply(c) {
    window.gtag('consent', 'update', {
      analytics_storage: c.analytics ? 'granted' : 'denied',
      ad_storage: c.advertising ? 'granted' : 'denied',
      ad_user_data: c.advertising ? 'granted' : 'denied',
      ad_personalization: c.advertising ? 'granted' : 'denied'
    });
    if (c.advertising) loadTag();
  }
  if (current) apply(current);

  /* The homepage banner's own memory predates the Advertising choice, so it is not consent to
     it. With no rk_consent cookie, forget it and let that banner ask again. */
  if (!current) { try { localStorage.removeItem('rk_cookie_choice'); } catch (e) {} }

  function choose(c) {
    current = { analytics: !!c.analytics, advertising: !!c.advertising, at: Date.now() };
    writeChoice(current);
    apply(current);
    hideOwnBanner();
    var hb = document.getElementById('cookie');
    if (hb) { hb.style.display = 'none'; hb.setAttribute('aria-hidden', 'true'); }
  }

  /* ---- conversions ---- */
  function seen(key) { try { return localStorage.getItem(key) === '1'; } catch (e) { return false; } }
  function mark(key) { try { localStorage.setItem(key, '1'); } catch (e) {} }
  window.rkConversion = function (name, opts) {
    opts = opts || {};
    var spec = CONVERSIONS[name];
    var done = false;
    var cb = typeof opts.callback === 'function' ? opts.callback : null;
    function finish() { if (!done) { done = true; if (cb) cb(); } }
    if (!spec || !spec.label || !current || !current.advertising || quiet) { finish(); return false; }
    var id = String(opts.transactionId || opts.id || opts.email || '').trim().toLowerCase();
    var key = 'rk_conv_v1:' + name + ':' + id;
    if (id && seen(key)) { finish(); return false; }
    loadTag();
    var email = String(opts.email || '').trim().toLowerCase();
    if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) window.gtag('set', 'user_data', { email: email });
    var params = {
      send_to: TAG + '/' + spec.label,
      value: typeof opts.value === 'number' ? opts.value : spec.value,
      currency: 'GBP',
      event_callback: finish
    };
    if (opts.transactionId) params.transaction_id = String(opts.transactionId);
    window.gtag('event', 'conversion', params);
    if (id) mark(key);
    /* A blocked or slow tag must never hold the page up. */
    if (cb) setTimeout(finish, 1200);
    return true;
  };

  /* ---- rockkt.com forms: the conversion on the server's real reply ----
     The demo form (/pages/sales-gifting) and the free-sample form (/pages/free-sample) live in
     templates, so rather than editing them this watches their own requests and reports a
     conversion only on the reply each form already treats as success:
       demo        POST https://app.rockkt.com/api/invite-request answered { ok: true }
       free_sample POST /contact carrying "Request type: Free sample", answered OK and not
                   redirected to Shopify's spam challenge page
     The page's own fetch is returned untouched; only a clone of the reply is read. */
  (function watchForms() {
    var path = location.pathname.replace(/\/+$/, '');
    var demoPage = /^\/pages\/sales-gifting$/.test(path);
    var samplePage = /^\/pages\/free-sample$/.test(path);
    if ((!demoPage && !samplePage) || typeof window.fetch !== 'function') return;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var p = orig.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = String((init && init.method) || 'GET').toUpperCase();
        var body = init && typeof init.body === 'string' ? init.body : '';
        if (method === 'POST' && demoPage && /\/api\/invite-request(\?|$)/.test(url)) {
          var em = ''; try { em = JSON.parse(body).email || ''; } catch (e) {}
          p.then(function (r) {
            return r.clone().json().then(function (j) { if (r.ok && j && j.ok === true) window.rkConversion('demo', { email: em }); });
          }).catch(function () {});
        }
        if (method === 'POST' && samplePage && /^(https?:\/\/[^\/]+)?\/contact(\?|$)/.test(url) && /contact\[Request%20type\]=Free%20sample/.test(body)) {
          var m2 = body.match(/(?:^|&)contact\[email\]=([^&]*)/);
          var em2 = ''; try { em2 = m2 ? decodeURIComponent(m2[1]) : ''; } catch (e) {}
          p.then(function (r) { if (r.ok && !/\/challenge/i.test(r.url || '')) window.rkConversion('free_sample', { email: em2 }); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  })();

  /* ---- the v1 banner (pages without the homepage banner) ---- */
  var CSS = '#rk-cc{position:fixed;left:16px;right:16px;bottom:16px;z-index:2147483000;max-width:440px;margin-left:auto;background:#0f1628;color:#f1f5f9;border:1px solid rgba(255,255,255,.14);border-radius:16px;padding:16px 16px 14px;box-shadow:0 18px 50px -12px rgba(0,0,0,.55);font:14px/1.5 Inter,system-ui,-apple-system,Segoe UI,sans-serif}' +
    '#rk-cc h2{font-size:15px;font-weight:800;margin:0 0 6px;color:#fff}' +
    '#rk-cc p{margin:0 0 12px;color:rgba(255,255,255,.86)}' +
    '#rk-cc a{color:#9fd0ff;text-decoration:underline}' +
    '#rk-cc .rk-cc-row{display:flex;gap:8px}' +
    '#rk-cc .rk-cc-btn{flex:1 1 0;min-height:42px;border-radius:10px;font:700 14px/1 inherit;font-family:inherit;cursor:pointer;border:1px solid rgba(255,255,255,.35);background:#fff;color:#0f1628}' +
    '#rk-cc .rk-cc-btn:focus-visible,#rk-cc .rk-cc-link:focus-visible{outline:3px solid #9fd0ff;outline-offset:2px}' +
    '#rk-cc .rk-cc-link{display:inline-block;margin-top:10px;background:none;border:0;padding:4px 0;color:#9fd0ff;font:600 13px/1.4 inherit;font-family:inherit;text-decoration:underline;cursor:pointer}' +
    '#rk-cc .rk-cc-opts{margin-top:10px;border-top:1px solid rgba(255,255,255,.14);padding-top:8px}' +
    '#rk-cc label{display:flex;gap:10px;align-items:flex-start;padding:6px 0;cursor:pointer;color:#f1f5f9}' +
    '#rk-cc label span small{display:block;color:rgba(255,255,255,.75);font-size:12.5px}' +
    '#rk-cc input[type=checkbox]{width:18px;height:18px;margin-top:2px;flex:0 0 auto}' +
    '#rk-cc .rk-cc-save{margin-top:8px;width:100%}' +
    '.rk-cc-footlink{background:none;border:0;padding:0;margin-left:12px;color:inherit;font:inherit;text-decoration:underline;cursor:pointer;opacity:.85}';
  var own = null;
  function hideOwnBanner() { if (own) { own.parentNode && own.parentNode.removeChild(own); own = null; } }
  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (text) n.textContent = text;
    return n;
  }
  function showOwnBanner(withOptions) {
    if (quiet) return;
    hideOwnBanner();
    if (!document.getElementById('rk-cc-css')) {
      var st = el('style', { id: 'rk-cc-css' }); st.textContent = CSS; document.head.appendChild(st);
    }
    own = el('div', { id: 'rk-cc', role: 'dialog', 'aria-label': 'Cookie choices', 'aria-live': 'polite' });
    own.appendChild(el('h2', {}, 'Cookies'));
    var p = el('p', {});
    p.appendChild(document.createTextNode('We use essential cookies to run this site. With your OK we also use advertising cookies to see which Google ads bring people to Rockkt, and analytics cookies to improve the site. Nothing is set until you choose. '));
    var pol = el('a', { href: POLICY_URL, target: '_blank', rel: 'noopener' }, 'Cookie Policy');
    p.appendChild(pol); p.appendChild(document.createTextNode('.'));
    own.appendChild(p);
    var row = el('div', { 'class': 'rk-cc-row' });
    var acc = el('button', { type: 'button', 'class': 'rk-cc-btn' }, 'Accept all');
    var rej = el('button', { type: 'button', 'class': 'rk-cc-btn' }, 'Reject all');
    acc.addEventListener('click', function () { choose({ analytics: true, advertising: true }); });
    rej.addEventListener('click', function () { choose({ analytics: false, advertising: false }); });
    row.appendChild(acc); row.appendChild(rej);
    own.appendChild(row);
    var more = el('button', { type: 'button', 'class': 'rk-cc-link', 'aria-expanded': 'false' }, 'Choose which cookies');
    own.appendChild(more);
    var opts = el('div', { 'class': 'rk-cc-opts', hidden: '' });
    function box(id, title, sub, checked, disabled) {
      var l = el('label', { 'for': id });
      var cb = el('input', { type: 'checkbox', id: id });
      cb.checked = !!checked; if (disabled) cb.disabled = true;
      var sp = el('span', {}, title); sp.appendChild(el('small', {}, sub));
      l.appendChild(cb); l.appendChild(sp);
      opts.appendChild(l);
      return cb;
    }
    box('rk-cc-ess', 'Essential', 'Keeps the site secure and working. Always on.', true, true);
    var a = box('rk-cc-ana', 'Analytics', 'Helps us see what is useful and improve the site.', current && current.analytics, false);
    var m = box('rk-cc-ads', 'Advertising', 'Lets Google tell us which of our ads brought you here.', current && current.advertising, false);
    var save = el('button', { type: 'button', 'class': 'rk-cc-btn rk-cc-save' }, 'Save my choices');
    save.addEventListener('click', function () { choose({ analytics: a.checked, advertising: m.checked }); });
    opts.appendChild(save);
    own.appendChild(opts);
    more.addEventListener('click', function () {
      var open = opts.hasAttribute('hidden');
      if (open) opts.removeAttribute('hidden'); else opts.setAttribute('hidden', '');
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (withOptions) { opts.removeAttribute('hidden'); more.setAttribute('aria-expanded', 'true'); }
    document.body.appendChild(own);
  }

  /* ---- the homepage banner, wired ---- */
  function wireHomeBanner(hb) {
    /* Its words: it now names advertising, and its policy link works. */
    var para = hb.querySelector('p');
    if (para) {
      para.textContent = 'We use essential cookies to run this site. With your OK we also use advertising cookies to see which Google ads bring people to Rockkt, and analytics cookies to improve the site. Nothing is set until you choose. ';
      var link = el('a', { href: POLICY_URL, target: '_blank', rel: 'noopener' }, 'Cookie Policy');
      para.appendChild(link); para.appendChild(document.createTextNode('.'));
    }
    /* An Advertising switch beside Analytics, same markup, starting off. */
    var ana = document.getElementById('swAnalytics');
    if (ana && !document.getElementById('swAdvertising')) {
      var rowEl = ana.closest('.ck-row');
      if (rowEl) {
        var clone = rowEl.cloneNode(true);
        var b = clone.querySelector('b'); if (b) b.textContent = 'Advertising';
        var s = clone.querySelector('.txt span'); if (s) s.textContent = 'Lets Google tell us which of our ads brought you here.';
        var sw = clone.querySelector('.ck-sw');
        sw.id = 'swAdvertising'; sw.classList.remove('on'); sw.setAttribute('aria-checked', 'false'); sw.setAttribute('aria-label', 'Advertising cookies');
        sw.addEventListener('click', function () {
          var on = sw.getAttribute('aria-checked') !== 'true';
          sw.setAttribute('aria-checked', on ? 'true' : 'false'); sw.classList.toggle('on', on);
        });
        rowEl.parentNode.insertBefore(clone, rowEl.nextSibling);
      }
    }
    if (current) { hb.style.display = 'none'; hb.setAttribute('aria-hidden', 'true'); }
  }
  /* Capture phase on the document: runs before the banner's own animation script holds the
     click, and again on its re-fired click, which is harmless (the same choice twice). */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('#ckAccept,#ckReject,#ckSave,[data-rk-cookie-settings],a[href="#cookie-settings"]') : null;
    if (!t) return;
    if (t.id === 'ckAccept') return choose({ analytics: true, advertising: true });
    if (t.id === 'ckReject') return choose({ analytics: false, advertising: false });
    if (t.id === 'ckSave') {
      var an = document.getElementById('swAnalytics'), ad = document.getElementById('swAdvertising');
      return choose({ analytics: !!an && an.getAttribute('aria-checked') === 'true', advertising: !!ad && ad.getAttribute('aria-checked') === 'true' });
    }
    e.preventDefault();
    window.rkConsent.open();
  }, true);

  /* ---- the footer link on rockkt.com ---- */
  function addFooterLink() {
    var bars = document.querySelectorAll('.foot-bottom');
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].querySelector('.rk-cc-footlink')) continue;
      var b = el('button', { type: 'button', 'class': 'rk-cc-footlink', 'data-rk-cookie-settings': '' }, 'Cookie settings');
      var first = bars[i].querySelector('span');
      if (first && first.parentNode === bars[i]) first.appendChild(b); else bars[i].appendChild(b);
    }
    if (bars.length && !document.getElementById('rk-cc-css')) {
      var st = el('style', { id: 'rk-cc-css' }); st.textContent = CSS; document.head.appendChild(st);
    }
  }

  window.rkConsent = {
    get: function () { return current ? { analytics: current.analytics, advertising: current.advertising } : null; },
    set: choose,
    open: function () {
      var hb = document.getElementById('cookie');
      if (hb) { hb.style.display = ''; hb.removeAttribute('aria-hidden'); return; }
      showOwnBanner(true);
    },
    version: 'v1'
  };

  function boot() {
    var hb = document.getElementById('cookie');
    if (hb) wireHomeBanner(hb);
    else if (!current) showOwnBanner(false);
    addFooterLink();
    /* The footer sync script rebuilds the bottom bar after load; put the link back. */
    setTimeout(addFooterLink, 1500);
    setTimeout(addFooterLink, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
